import { Quote } from './quote.model';

export class CarQuote extends Quote {
  opportunitiesId?: number;
  quoteId?: number;
  quoteDate?: Date;
  jobNumber?: number;
  policyPeriodId?: number;
  currency?: string;
  premium?: number;
  franchiseValue?: number;
  franchiseType?: string;
  franchiseId?: number;
  effectiveDate?: Date;
  expirationDate?: Date;
  isSelected?: boolean;
  quoteStatus?: string;
  franchiseDescription?: string;
  franchiseShortDescription?: string;
  productName?: string;
  coverageKey?: string;
  policyNumber?: number;
}
